import fetchFromKong from './fetchFromKong';
import { trackEvent } from './trackEvent';

export const areServicesHealthy = async (
	isOccasion: boolean,
	isFlex: boolean
): Promise<boolean> => {
	const trackEventForAppHealth = (status: string) => {
		trackEvent({
			event: 'error_info',
			category: 'page',
			// eslint-disable-next-line no-nested-ternary
			type: `private lease${isOccasion ? ' occasion' : isFlex ? ' flex' : ''}`,
			status,
			text: 'door een technische storing is het tijdelijk niet mogelijk om online een aanvraag te doen',
		});
	};

	try {
		const response = await fetchFromKong('privatelease/v1/leaseplan/leasecars/lead-health-status');
		if (response.status === 503) {
			trackEventForAppHealth('503 Service Unavailable');
			return false;
		}
		return true;
	} catch (error) {
		trackEventForAppHealth('health check failed');
		return false;
	}
};
